// src/aboutContent.js
export const aboutContent = {
  en: {
    title: "Learn Hangul Instantly, Using Your Own Language",
    paragraphs: [
      "Most learning tools introduce language and script at the same time. But I choose a different starting point — a sound-first approach.",
      
      "Type a word in your native language, and 세종의 후예 (Sejong's Heir) instantly shows how that sound is written in Hangul. As you connect familiar sounds with Hangul consonants and vowels, you'll naturally reach that moment: \"Oh, so THIS is how Hangul works!\"",
      
      "Watch how each character is built from consonant + vowel. Once you understand the elegant system created by King Sejong, Hangul doesn't need memorization. It simply begins to make sense.",
      
      "English, Japanese, Vietnamese, Thai, Spanish, French, Italian… No matter what language you speak, if you can type its sounds, you can start reading and writing Hangul today. This is the method of 세종의 후예 (Sejong's Heir)."
    ]
  },
  ja: {
    title: "あなたの母語だけで、今すぐハングルを学べます",
    paragraphs: [
      "多くの学習ツールは、言語と文字を同時に提示して学習を始めます。しかし私は、それよりも「音」から始めるアプローチを選びました。",
      
      "세종의 후예（世宗の後裔）に母語の単語を入力すると、その音がハングルでどのように表記されるかを瞬時に知ることができます。親しみのある音とハングルの子音・母音がつながっていくと、「なるほど、ハングルはこうやって仕組まれているんだ！」という瞬間が訪れます。",
      
      "ハングルが子音＋母音で組み立てられる様子を目で確かめてください。世宗大王が作り上げたこの論理を理解すれば、暗記は必要ありません。自然に\"読める\"ようになります。",
      
      "英語、日本語、ベトナム語、タイ語、スペイン語、フランス語、イタリア語…どの言語でも大丈夫。母語の音を入力するだけで、今日からハングルを読んで書けるようになります。これが세종의 후예（世宗の後裔）のメソッドです。"
    ]
  },
  vi: {
    title: "Học Hangul Ngay Lập Tức Bằng Chính Ngôn Ngữ Của Bạn",
    paragraphs: [
      "Hầu hết công cụ học tập đều bắt đầu bằng cách giới thiệu ngôn ngữ và chữ viết cùng lúc. Còn tôi chọn một cách khác — bắt đầu từ âm thanh.",
      
      "Chỉ cần nhập một từ trong tiếng mẹ đẻ, 세종의 후예 (Hậu Duệ Sejong) sẽ hiển thị ngay âm đó được viết bằng Hangul như thế nào. Khi bạn nối các âm quen thuộc với phụ âm và nguyên âm Hangul, sẽ có khoảnh khắc: \"À, hóa ra Hangul hoạt động thế này!\"",
      
      "Hãy xem từng ký tự được tạo nên từ phụ âm + nguyên âm. Khi hiểu được hệ thống tinh tế do vua Sejong tạo ra, bạn không cần phải học thuộc. Hangul sẽ tự nhiên trở nên rõ ràng.",
      
      "Tiếng Anh, Nhật, Việt, Thái, Tây Ban Nha, Pháp, Ý… Bất kể bạn nói ngôn ngữ nào, chỉ cần nhập âm thanh của tiếng đó, bạn có thể đọc và viết Hangul ngay hôm nay. Đó là phương pháp của 세종의 후예 (Hậu Duệ Sejong)."
    ]
  },
  th: {
    title: "เรียนฮันกึลได้ทันที ด้วยภาษาของคุณเอง",
    paragraphs: [
      "เครื่องมือการเรียนรู้ส่วนใหญ่มักเริ่มต้นด้วยการให้คุณเรียนภาษาและตัวอักษรพร้อมกัน แต่ฉันเลือกอีกเส้นทางหนึ่ง — เส้นทางที่เริ่มจาก \"เสียง\" ก่อน",
      
      "เพียงพิมพ์คำในภาษาแม่ของคุณ 세종의 후예 (ทายาทของเซจง) จะแสดงทันทีว่าเสียงนั้นเขียนด้วยฮันกึลอย่างไร เมื่อคุณเชื่อมเสียงที่คุ้นเคยกับพยัญชนะและสระของฮันกึล จะมีจังหวะที่คุณพูดว่า: \"อ้อ! ฮันกึลทำงานแบบนี้เอง!\"",
      
      "ลองดูว่าตัวอักษรแต่ละตัวประกอบจากพยัญชนะ + สระอย่างไร เมื่อเข้าใจระบบที่กษัตริย์เซจงสร้างขึ้น คุณไม่จำเป็นต้องท่องจำเลย ฮันกึลจะเริ่ม 'อ่านออก' โดยธรรมชาติ",
      
      "อังกฤษ ญี่ปุ่น เวียดนาม ไทย สเปน ฝรั่งเศส อิตาลี… ไม่ว่าคุณจะพูดภาษาอะไร แค่พิมพ์เสียงของภาษานั้น คุณก็เริ่มอ่านและเขียนฮันกึลได้ทันทีวันนี้ นี่คือวิธีของ 세종의 후예 (ทายาทของเซจง)"
    ]
  },
  es: {
    title: "Aprende Hangul Al Instante Usando Tu Propio Idioma",
    paragraphs: [
      "La mayoría de las herramientas empiezan mostrando el idioma y el sistema de escritura al mismo tiempo. Yo prefiero comenzar desde otro lugar: el sonido.",
      
      "Escribe una palabra en tu lengua y 세종의 후예 (Heredero de Sejong) te mostrará al instante cómo se representa ese sonido en Hangul. Al conectar sonidos familiares con las consonantes y vocales del Hangul, llega ese momento: \"¡Ah, así funciona el Hangul!\"",
      
      "Observa cómo cada letra se forma a partir de consonante + vocal. Cuando comprendes el sistema elegante creado por el Rey Sejong, ya no necesitas memorizar. El Hangul simplemente empieza a tener sentido.",
      
      "Inglés, japonés, vietnamita, tailandés, español, francés, italiano… Da igual qué idioma hables: si puedes escribir sus sonidos, hoy mismo puedes comenzar a leer y escribir Hangul. Ese es el método de 세종의 후예 (Heredero de Sejong)."
    ]
  },
  fr: {
    title: "Apprenez le Hangeul Immédiatement, À Partir de Votre Propre Langue",
    paragraphs: [
      "La plupart des outils d'apprentissage présentent la langue et l'alphabet en même temps. Mais je choisis une autre voie — une approche centrée sur le son.",
      
      "Tapez un mot dans votre langue, et 세종의 후예 (Héritier de Sejong) vous montre instantanément comment son son se transcrit en hangeul. En reliant des sons familiers aux consonnes et voyelles du hangeul, vous aurez ce moment : \"Ah, voilà comment fonctionne le hangeul !\"",
      
      "Observez comment chaque caractère se construit à partir d'une consonne + voyelle. Une fois la logique élégante conçue par le Roi Sejong comprise, vous n'avez plus besoin de mémoriser. Le hangeul devient naturellement clair.",
      
      "Anglais, japonais, vietnamien, thaï, espagnol, français, italien… Peu importe votre langue : si vous pouvez en taper les sons, vous pouvez commencer à lire et écrire le hangeul dès aujourd'hui. C'est la méthode de 세종의 후예 (Héritier de Sejong)."
    ]
  },
  it: {
    title: "Impara l'Hangul Subito, Usando la Tua Lingua",
    paragraphs: [
      "La maggior parte degli strumenti presenta lingua e scrittura allo stesso tempo. Io preferisco un punto di partenza diverso — un approccio basato sul suono.",
      
      "Scrivi una parola nella tua lingua e 세종의 후예 (Erede di Sejong) ti mostrerà immediatamente come quel suono viene reso in Hangul. Collegando suoni familiari con consonanti e vocali dell'Hangul, arriverà il momento: \"Ah, quindi funziona così!\"",
      
      "Guarda come ogni carattere nasce da consonante + vocale. Quando comprendi il sistema elegante creato dal Re Sejong, non serve più memorizzare. L'Hangul inizia semplicemente a rivelarsi.",
      
      "Inglese, giapponese, vietnamita, thailandese, spagnolo, francese, italiano… Non importa quale lingua parli: se puoi digitarne i suoni, puoi iniziare a leggere e scrivere l'Hangul già oggi. Questa è la via di 세종의 후예 (Erede di Sejong)."
    ]
  },
  ko: {
    title: "당신의 언어로, 지금 바로 한글을 배워보세요",
    paragraphs: [
      "많은 학습 도구는 언어와 문자를 동시에 보여주며 출발합니다. 하지만 나는 그보다 더 '소리 중심'의 출발을 선택했습니다.",
      
      "「세종의 후예」는 당신의 모국어를 입력하면, 그 소리가 한글에서 어떻게 표현되는지 즉시 보여줍니다. 이미 알고 있는 발음에 한글 자모를 하나씩 연결해 가며, 자연스럽게 \"아, 한글이 이렇게 돌아가는구나!\" 하고 감이 오는 순간을 느끼게 될 거예요.",
      
      "각 글자가 자음 + 모음으로 조립되는 과정을 직접 눈으로 확인해보세요. 세종대왕이 만든 이 정교한 원리를 이해하면, 한글은 외울 필요가 없습니다. 그냥 '보이기' 시작합니다.",
      
      "영어, 일본어, 베트남어, 태국어, 스페인어, 프랑스어, 이탈리아어… 어떤 언어를 쓰든 괜찮아요. 당신의 언어 소리만 입력하면, 오늘부터 한글을 읽고 쓸 수 있습니다. 이것이 바로 「세종의 후예」만의 방식입니다."
    ]
  }
};

export const languages = [
  { code: 'en', name: 'English', flag: '🇺🇸' },
  { code: 'ja', name: '日本語', flag: '🇯🇵' },
  { code: 'vi', name: 'Tiếng Việt', flag: '🇻🇳' },
  { code: 'th', name: 'ภาษาไทย', flag: '🇹🇭' },
  { code: 'es', name: 'Español', flag: '🇪🇸' },
  { code: 'fr', name: 'Français', flag: '🇫🇷' },
  { code: 'it', name: 'Italiano', flag: '🇮🇹' },
  { code: 'ko', name: '한국어', flag: '🇰🇷' }
];